<template>
  <footer class="position-absolute pos-bottom pos-left pos-right p-3 text-center">
    2019 © {{ appTitle }} by&nbsp;
  </footer>
</template>

<script>
import { mapState } from 'vuex';

// @vuese
// Stopka dla niezalogowanego użytkownika
// @group StartLayout
export default {
  name: 'Footer',
  computed: {
    ...mapState({
      appTitle: state => state.system.appTitle
    })
  }
};
</script>
